/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Joy.xushaojia
 * @Date: 2023-12-25 11:37:25
 * @LastEditors: Joy.xushaojia
 * @LastEditTime: 2023-12-25 11:45:47
 */
import { RouteObject, useRoutes } from "react-router-dom"
import { Suspense } from "react"
import { SpinLoading } from "antd-mobile"
import userModule from './modules/user'

const routes: AsyncRoute.Routes[] = [...userModule]

const asyncRouter = (table: AsyncRoute.Routes[]): RouteObject[] => {
    const RoutesTable: RouteObject[] = [];
  
    table.forEach((route) => {
      RoutesTable.push({
        path: route.path,
        element: (
          <Suspense fallback={route.skeleton || <SpinLoading color='primary' />}>
            <route.component />
          </Suspense>
        ),
        children: route.children && asyncRouter(route.children),
      });
    });
  
    return RoutesTable;
  };
  
  const Router = () => useRoutes(asyncRouter(routes));
  
  export default Router